import styled from "@emotion/styled";
import { East } from "@mui/icons-material";
import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import { motion, useScroll, useTransform } from "framer-motion";
import { RefObject, forwardRef, memo } from "react";

interface CapabilitiesFloatingSectionProps {
  title: string;
  description: string;
  linkPath: string;
  height?: number; // Provide the height of the section in units of VH (100 = 100vh)
  direction?: number;
}

const CapabilitiesFloatingSection = forwardRef<
  HTMLDivElement,
  CapabilitiesFloatingSectionProps
>(({ title, description, linkPath, height = 100, direction = 1 }, ref) => {
  // const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref as RefObject<HTMLElement> | undefined,
    offset: ["start start", "start end"],
  });

  const opacityButton = useTransform(scrollYProgress, [0, 0.1], ["1", "0"]);
  const opacity = useTransform(scrollYProgress, [0, 0.6], ["1", "0"]);

  const rotateY = useTransform(
    scrollYProgress,
    [0.0, 1.0],
    ["0deg", direction === 1 ? "80deg" : "-80deg"]
  );

  const rotateX = useTransform(scrollYProgress, [0.0, 2.0], ["5deg", "15deg"]);

  const theme = useTheme();

  return (
    <StyledSectionBox
      onClick={() => console.log("Clicked")}
      height={height}
      ref={ref}
    >
      <Stack gap={2} sx={{ perspective: "1000px" }}>
        <motion.div style={{ rotateX, rotateY, opacity }}>
          <StyledSectionHeader
            theme={theme}
            variant="textXLBold"
            fontWeight={200}
            color={theme.palette.common.black}
          >
            {title}
          </StyledSectionHeader>
        </motion.div>
        <motion.div style={{ rotateX, rotateY, opacity }}>
          <Typography variant="displayMDBold" lineHeight={1.4}>
            {description}
          </Typography>
        </motion.div>

        <motion.div style={{ opacity: opacityButton }}>
          <Button
            variant="contained"
            endIcon={<East />}
            href={linkPath}
            sx={{
              background: theme.palette.gradients.wildGreenBoy,
              color: theme.palette.primary.main,
              textTransform: "capitalize",
              fontWeight: 700,
              width: "auto",
              mt: 3,
            }}
            disableElevation
          >
            Explore{" "}
            {title.indexOf("GenAI") > -1
              ? "Generative AI Development"
              : title.toLowerCase()}
          </Button>
        </motion.div>
      </Stack>
    </StyledSectionBox>
  );
});

export default memo(CapabilitiesFloatingSection);

interface StyledSectionBoxProps {
  height: number;
}

const StyledSectionBox = styled(Box)<StyledSectionBoxProps>`
  height: ${(props) => props.height}vh;
  //padding-left: 28px;
  max-width: 478px;
  pointer-events: auto;
  display: flex;
  align-items: center;
`;

interface StyledSectionHeaderProps {
  theme: any;
}

const StyledSectionHeader = styled(Typography)<StyledSectionHeaderProps>`
  position: relative;

  /*
  ${(props) => props.theme.breakpoints.up("lg")} {
    &::before {
      content: "";
      position: absolute;
      width: 20px;
      height: 2px;
      background-color: black;
      top: calc(50% - 2px);
      left: -28px;
    }
  }
  */
`;
